export const Fonts = {
  POPPINS: 'font-family: futura-pt, sans-serif',
  GOTHIC: 'font-family: futura-pt, sans-serif',
};
